import React from 'react';
import landigImage from '../../../assets/images/landing.png';
import landigImageSm from '../../../assets/images/landing.jpg';
import roomIcon from '../../../assets/images/aboutUs.png';
import scrollIcon from '../../../assets/images/scrollIcon.png';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../store/langSlice';
import { getLang } from '../../../environnement';

export default function LandingImage({
  onClickScrollIcon,
}) {
  const lang = useSelector(langSelector);

  return (
    <>
      <div className='lg:hidden 2xl:block relative mb-[450px] sm:mb-80 w-full' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className={`absolute inset-0 bg-bottom bg-cover bg-bottom flex-grow w-full ${lang === 'fr' ? 'h-[480px] xxs:h-[400px]' : 'h-[460px] xxs:h-[420px]'} sm:h-80`} style={{backgroundImage: `url(${landigImageSm})`}}>
        </div>
        <div className={`absolute inset-0 w-full ${lang === 'fr' ? 'h-[480px] xxs:h-[400px]' : 'h-[460px] xxs:h-[420px]'} sm:h-80 2xl:flex 2xl:justify-center`} style={{backgroundColor: 'rgba(163, 23, 50, 0.8)'}}>
          <div className='2xl:w-[1200px]'>
            <div className='flex flex-col sm:flex-row'>
              <div className='sm:py-5 mx-10'>
                <p className='text-white text-2xl xxs:text-3xl font-medium mt-5' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).accueil.landingTitle}</p>
                <p className='text-white text-lg xxs:text-xl font-regular mt-10' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).accueil.landingSubtitle}</p>
              </div>
              <div className='h-full sm:w-full mr-10 ml-10 sm:ml-0'>
                <div onClick={() => window.open('http://www.fmpm.uca.ma/?page_id=5017', '_blank')} className='w-[185px] sm:w-full rounded-[10px] bg-primary hover:bg-primaryDark py-2 px-5 mb-5 cursor-pointer flex sm:flex-col justify-center items-center border border-white mt-10'>
                  <img src={roomIcon} alt='roomIcon' className='w-10 mr-5 sm:mr-0'/>
                  <p className='text-white font-regular text-xl sm:text-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).accueil.buttonLanding}</p>
                </div>
              </div>
            </div>
          </div>
          <img src={scrollIcon} alt='scrollIcon' className='hidden xxs:block absolute bottom-12 right-8 w-10 h-10 animate-bounce cursor-pointer' onClick={onClickScrollIcon}/>
        </div>
      </div>
      <div className='hidden lg:block 2xl:hidden'>
        <div class="relative bg-bottom bg-cover bg-bottom flex-grow w-full" style={{backgroundImage: `url(${landigImage})`, transform: lang === 'ar' ? 'scaleX(-1)' : 'none',}}>
          <div className='py-5'>
            <p className='text-white text-4xl font-medium ml-10 w-[550px] transform-none' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).accueil.landingTitle}</p>
            <p className='text-white text-2xl font-regular ml-10 w-[450px] mt-10' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).accueil.landingSubtitle}</p>
              <div onClick={() => window.open('http://www.fmpm.uca.ma/?page_id=5017', '_blank')} className='rounded-[10px] bg-primary hover:bg-primaryDark py-2 px-5 mb-5 cursor-pointer flex justify-between items-center w-[185px] h-[100px] border border-white ml-10 mt-10'>
                <img src={roomIcon} alt='roomIcon' className='w-10 mr-5'/>
                <p className='text-white font-regular text-xl' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).accueil.buttonLanding}</p>
              </div>
          </div>
          <img src={scrollIcon} alt='scrollIcon' className='absolute bottom-9 right-10 w-10 h-10 animate-bounce cursor-pointer' onClick={onClickScrollIcon}/>
        </div>
        {/* <img src={landigImage} alt='landing' className='w-full flex-grow'/> */}
      </div>
    </>
  );
}
